import { render } from "./Quality.vue?vue&type=template&id=d6370bd4&ts=true"
import script from "./Quality.vue?vue&type=script&lang=ts"
export * from "./Quality.vue?vue&type=script&lang=ts"

import "./Quality.vue?vue&type=style&index=0&id=d6370bd4&lang=less"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__